import React, {useState} from "react";
import HeaderContainer from "../../assets/img/menu_bar_top_line.png";
import FooterContainer from "../../assets/img/menu_bar_bottom_line.png";
import {FrontendRoutes} from "../../constants";
import {useLocation} from "react-router";
import HeadMenuItem from "./HeadMenuItem";
import HeadMenuDropdown from "./dropdown/HeadMenuDropdown";


const ProgramHeader = ({user}) => {

    const l = useLocation();
    const [openDropdown, setOpenDropdown] = useState(false);

    React.useEffect(() => {
        openDropdown && setOpenDropdown(false);
    }, [l]);

    return (
        <div className={"prog-header-container"}>
            <div style={{height: "15px"}}>
                <img
                    alt={""}
                    src={HeaderContainer}
                    style={{width: "100%", height: "5px"}}
                />
            </div>
            <div style={{display: 'flex'}}>
                <ul id="nav">
                    <HeadMenuItem route={FrontendRoutes.HOME} label={'Home'}/>
                    <HeadMenuItem route={FrontendRoutes.PROGRAMME} label={'Programme'}/>
                    <HeadMenuItem route={FrontendRoutes.BALLROOM()} label={'Ballroom'}/>
                    <HeadMenuItem route={FrontendRoutes.CONVERSATION} label={'In Conversation'}/>
                    <HeadMenuItem route={FrontendRoutes.PHOTO_BOOTH} label={'Photo Booth'} />
                    <HeadMenuItem route={FrontendRoutes.SOCIAL_WALL} label={'Social Wall'} />
                    <HeadMenuDropdown openDropdown={openDropdown}
                                      setOpenDropdown={setOpenDropdown}
                                      user={user}/>
                </ul>
            </div>
            <img
                alt={""}
                src={FooterContainer}
                style={{width: "100%", height: "5px"}}
            />
        </div>
    );
};

export default ProgramHeader;
